import { render } from "./ModalGraficoUnidad.vue?vue&type=template&id=bb8bc712"
import script from "./ModalGraficoUnidad.vue?vue&type=script&lang=js"
export * from "./ModalGraficoUnidad.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__